module.exports = __webpack_public_path__ + "static/media/RKProjectPreview1870@2x.88521c05.jpg";